import { render, staticRenderFns } from "./EditContractor.vue?vue&type=template&id=72d024dc"
import script from "./EditContractor.vue?vue&type=script&lang=js"
export * from "./EditContractor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports